import { Stack, Typography } from '@mui/material'
import { Button, InformationModal } from 'utoniq-ui'

import { PointHeaderDisplay } from '@/components/organisms'
import { useTranslation } from '@/core'

export type InsufficientGachaTicketModalProps = {
  open: boolean
  onClose: () => void
  point: number
  prepaidPointBalance: number | null
  onClick: () => void
  gachaRolling: boolean
  disabled?: boolean
}
/**
 * @description
 * ガチャチケ・ポイント量対応のガチャで、ガチャチケ不足時にポイントでガチャを引けるモーダル
 */
export const InsufficientGachaTicketModal = ({
  open,
  onClose,
  point,
  prepaidPointBalance,
  onClick,
  gachaRolling,
  disabled,
}: InsufficientGachaTicketModalProps) => {
  const { t } = useTranslation('gachaDetail')

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('insufficientGachaTicketTitle')}
      content={
        <Stack sx={{ pb: 4 }}>
          <Typography variant="body2" sx={{ pb: 8 }}>
            {t('insufficientGachaTicketContent')}
          </Typography>

          <PointHeaderDisplay
            size="large"
            point={point}
            sx={{ alignSelf: 'center', mb: 4 }}
          />

          <Typography>
            {t('prepaidPointBalance', { prepaidPointBalance })}
          </Typography>
        </Stack>
      }
      buttons={
        <Button
          size="large"
          loading={gachaRolling}
          sx={{ minWidth: 200 }}
          onClick={onClick}
          disabled={disabled}
        >
          {t('draw')}
        </Button>
      }
      cancelText={t('close')}
    />
  )
}
